import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const AlpheraFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Alphera"
      slug="/lenders/mis-sold-alphera-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default AlpheraFinancePage
